export default __webpack_public_path__ + "static/media/CelKilt.2af9c692.mp3";